import {getLastStopTime} from "./getEndTime";
import moment from "moment";
import {ICollation} from "../components/planner/@models";

export const isPastDeadLine = (collations: Array<ICollation>) => {
  const calculateEndTime = getLastStopTime(collations)
  return calculateEndTime && calculateEndTime.isAfter(moment({'h': 22}))
}
